(function() {
    angular.module('meanApp')
    .directive('keepScrollPos', keepScrollPos);
    
    keepScrollPos.$inject=['$rootScope', '$state', '$window', '$timeout', '$location', '$anchorScroll'];
    function keepScrollPos ($rootScope, $state, $window, $timeout, $location, $anchorScroll) {

        // cache scroll position of each route's templateUrl
        var scrollPosCache = {};

        // compile function
        return {
            restrict: 'EA',
            link: function(scope, element, attrs) {

                scope.$on('$locationChangeStart', function(rootscope, nextURL, previousURL) {
                    // store scroll position for the current view
                    if (previousURL) {
                        scrollPosCache[previousURL] = [ $window.pageXOffset, $window.pageYOffset ];
                    }
                });

                scope.$on('$locationChangeSuccess', function(rootscope, nextURL, previousURL) {
                    // if hash is specified explicitly, it trumps previously stored scroll position
                    if ($location.hash()) {
                        $anchorScroll();

                    // else get previous scroll position; if none, scroll to the top of the page
                    } else {
                        var prevScrollPos = scrollPosCache[nextURL] || [ 0, 0 ];
                        $timeout(function() {
                            $window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
                        }, 0);
                    }
                });

            }
        };     
    }
})();

